import { Link, useMatch, useNavigate, useResolvedPath } from "react-router-dom";

import { faHome, faSignOut, faUsers } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import classes from "./MainNavigation.module.css";

function MainNavigation(props) {
    const navigate = useNavigate();

    return (
        <header>
            <div className={`interface ${classes.interface}`}>
                <div className={classes.logo}>
                    <a href="/">
                        <img src="/img/logo.png" alt="Logo" />
                    </a>
                </div>

                <nav className={classes.menuDesktop}>
                    <ul>
                        {!props.isLoggedIn &&
                            <>
                                <li>
                                    <a href="/servicos">SERVIÇOS</a>
                                </li>
                                <li>
                                    <a href="/portfolio">PORTFOLIO</a>
                                </li>
                                <li>
                                    <a href="/contato">CONTATO</a>
                                </li>
                            </>
                        }
                        {props.isLoggedIn &&
                            <>
                                <a href="/admin"><h3><FontAwesomeIcon icon={faHome} />&nbsp;ÁREA ADMINISTRATIVA</h3></a>
                            </>
                        }
                    </ul>
                </nav>

                {!props.isLoggedIn &&
                    <div className={classes.btnContato}>
                        <Link to="/login">
                            <button><FontAwesomeIcon icon={faUsers} />&nbsp;LOGIN</button>
                        </Link>
                    </div>
                }

                {props.isLoggedIn &&
                    <div className={classes.btnContato}>
                        {/* <Link to="/logout"> */}
                        <button onClick={props.onLogout}><FontAwesomeIcon icon={faSignOut} />&nbsp;LOGOUT</button>
                        {/* </Link> */}
                    </div>
                }

                <div className={classes.btnAbrirMenu} id="btnMenu">
                    <i className="bi bi-list"></i>
                </div>

                <div className={classes.menuMobile} id="menuMobile">
                    <div className={classes.btnFechar}>
                        <i className="bi bi-x-lg"></i>
                    </div>

                    <nav>
                        <ul>
                            <li>
                                <a href="/">INÍCIO</a>
                            </li>
                            <li>
                                <a href="/">ESPECIALIDADES</a>
                            </li>
                            <li>
                                <a href="/">SOBRE</a>
                            </li>
                            <li>
                                <a href="/">PROJETOS</a>
                            </li>

                            <li>
                                <a href="/">CONTATO</a>
                            </li>
                        </ul>
                    </nav>
                </div>

                <div className={classes.overlayMenu} id="overlayMenu"></div>

            </div>
        </header>
    );
}

export default MainNavigation;


// function CustomIconLink({ to, children, ...props }) {
//     const resolvedPath = useResolvedPath(to);
//     const isActive = useMatch({ path: resolvedPath.pathname, end: true })
//     return (
//         <li className={isActive ? "active onlyIcon" + (props.className ? " " + props.className : "") : "onlyIcon" + (props.className ? " " + props.className : "")}>
//             <Link to={to} {...props}>{children}</Link>
//         </li>
//     )
// }

// function CustomLink({ to, children, ...props }) {
//     const resolvedPath = useResolvedPath(to);
//     const isActive = useMatch({ path: resolvedPath.pathname, end: true })
//     return (
//         <li className={isActive ? "active" + (props.className ? " " + props.className : "") : "" + (props.className ? " " + props.className : "")}>
//             <Link to={to} {...props}>{children}</Link>
//         </li>
//     )
// }